module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "chapaut"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "Images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BARBRA STREISAND")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pat Conroy was a force for good in our world. With courage and grace, he brought the gifts of the devastating beauty of his writing and his transcendent vision of the human heart to the lives of the readers he touched and the writers he inspired. Long after his days in the classroom had ended, Pat continued to teach all of us through his generous example of how an artist can live in service and gratitude to others. In bravely telling his story, as only he could, Pat emboldened others to see the difficult truths of their own lives, but he also welcomed us to glimpse the possibility of transformation and salvation through love and loss. In October 2015, just before Pat’s seventieth birthday, what would tragically be his last, I wrote him the following letter, sent from my heart to his. The words still ring true. As writers gather in these pages to honor Pat with our collective remembrances of him and of the lessons he passed on to us, I am delighted for this opportunity to share my letter to Pat once more—in recognition of my teacher, my student, my dear friend, our prince of tides.")]), _vm._v(" "), _c('p', {
    staticClass: "common"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image",
      "src": "Images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("October 1, 2015")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Dear Pat,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, I fell in love with your book, and then I fell in love with you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I started reading "), _c('em', [_vm._v("The Prince of Tides")]), _vm._v(" and couldn’t put it down. I’m always drawn to stories about transformation—love and loss—and the secrets that can destroy you until you bring them into the light. I responded to the "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("theme of forgiveness—being able to accept people with all their flaws. And I personally believe in the healing power of therapy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as I finished the book, I started to visualize it as a movie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wanted to know everything about the characters. I wanted to know Tom. How could I know Tom? By getting to know the man who created him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So I invited you to come see me in New York, and we spent two wonderful weeks together. I just wanted to hear your stories—about your father, your mother, your family, your whole life. I was greedy for any detail that would help me flesh out the characters and understand the world of the movie. I’m far from a southerner, but one of your wives was Jewish, from Brooklyn, so I took that as a good sign. I knew you’d understand me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the first moment we started talking, you were so generous and kind, humble and loving. I vividly remember you teaching me how to do the Shag. It’s a dance that was mentioned in the book, so I said, “Could you show me how to do it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, talk about transformation! Suddenly this rather shy, courtly southern gentleman turned into a hip-shaking hepcat. Loose as a goose. Boy, you could really fling that tush around! I’m shy, too—another reason we got along—and I rarely get up and dance. But we had such fun, dancing the Shag in my office. I don’t think I was even doing the right steps but it didn’t matter because you were "), _c('em', [_vm._v("so good")]), _vm._v(". You took my hand and swung me in and out and I just followed you. I was so impressed with your footwork!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You were such a joy to work with, Pat. I was so honored that you entrusted your beautiful book to me. And besides the book, you gave me another gift.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My son Jason wanted to play Bernard but I thought that might be complicated. Could he take direction from me, his mom? So I had hired someone else. But then you saw a photograph of Jason in a crystal frame on the piano in my den and you looked at it and said, “That’s Bernard.” Dark, curly hair, expressive eyes, full lips, and prominent nose (like his mother), just as you describe him in the book. It says Bernard weighs 140 pounds. I called Jason up and asked, “How much do you weigh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jason said, “One hundred forty pounds. Why?”"), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “You’re hired.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because of your encouragement, I got to work with my son. It was you, Pat, who made that happen. And Jason was wonderful in the role. He "), _c('em', [_vm._v("was")]), _vm._v(" Bernard, in a way. And he learned how to play that very difficult violin piece in the middle of Grand Central Station. I was so proud. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I once read an interview where you were quoted as saying that working with me was like working with the goddess Athena. That was extremely generous of you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, if I’m Athena, you’re my Apollo—the god of poetry, truth, and music. Your natural language is poetry. You write sentences that are like an incantation. You observe every nuance of human behavior and dig deep down to the truth, presenting it in all its glorious and stubborn complexity. And as far as music goes, let’s just say you can come back and dance with me any time!")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("I’m sending you all my love and gratitude,")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Barbra Streisand")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("P.S. Happy Birthday!"), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fa4b8c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/foreword.vue
// module id = 72
// module chunks = 0